<template>
    <Layout>
        <section class="section">
            <div class="container">
                <div class="no-free-will">
                    <p class="lead">
                        The 16<sup>th</sup> Annual One on One Conference is
                        being held at Atlantis, the Palm, a luxury resort
                        located at the apex of the Palm Jumeirah in Dubai,
                        United Arab Emirates (UAE)
                    </p>

                    <p>
                        Combining extravagant luxury and high-tech facilities
                        with old-world charm, Dubai has fast become one of the
                        world’s most popular tourist destinations, renowned for
                        its warm hospitality and iconic skyscrapers, opulent
                        shopping centers, indoor theme parks and decadent
                        culinary options.
                    </p>

                    <p>
                        In line with the government’s decision to diversify from
                        a trade-based, oil-reliant economy to one that is
                        service and tourism-oriented, Dubai embarked on a period
                        of infrastructural development and expansion over the
                        last few decades, owing to its emergence as a
                        cosmopolitan metropolis that has grown steadily to
                        become a business and cultural hub of the Middle East.
                    </p>

                    <p>
                        With its abundance of attractions, activities,
                        exhibitions, shopping and nightlife, Dubai retained its
                        ranking as the fourth most visited city in the world for
                        the fourth year in a row, with more than 15.9 million
                        overnight visitors in 2018.
                    </p>
                </div>
            </div>
        </section>

        <section id="contacts">
            <div class="contacts-wrapper">
                <div
                    id="contacts-map"
                    class="map"
                    data-settings="venue-map-settings.json"
                    style="height:560px;"
                ></div>

                <div class="container contacts-on-map-container">
                    <div class="contacts-on-map">
                        <h3>Atlantis, The Palm Hotel</h3>

                        <ul class="list">
                            <li>
                                <i class="fa fa-map-marker"></i>Crescent Road,
                                The Palm Island, P.O.Box 211222, Dubai, UAE
                            </li>
                            <li><i class="fa fa-phone"></i>+971 4 426 2000</li>
                            <li>
                                <i class="fa fa-envelope"></i
                                ><a href="mailto:info@atlantisthepalm.com"
                                    >info@atlantisthepalm.com</a
                                >
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>

        <section class="section">
            <div class="container">
                <div class="no-free-will">
                    <img src="/assets/img/hotel/atlantis-2.jpg" alt="" />
                    <p class="caption">Atlantis, The Palm, Dubai, UAE</p>
                </div>
            </div>
        </section>

        <section class="section gray-clr-bg">
            <div class="container">
                <div class="no-free-will">
                    <div class="row">
                        <div class="bottom-links">
                            <div class="col-md-6">
                                <a
                                    href="#"
                                    class="btn btn-sm btn-secondary btn-block"
                                    >Participation Guidelines (Presenters)</a
                                >
                            </div>
                            <div class="col-md-6">
                                <a
                                    href="#"
                                    class="btn btn-sm btn-secondary btn-block"
                                    >Brochure (Investors)</a
                                >
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </Layout>
</template>

<script>
import Layout from "@/components/layouts/Layout.vue";

export default {
    name: "Venue",
    components: { Layout }
};
</script>
